import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { RetryLink } from '@apollo/client/link/retry';

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_API_URL || 'https://ok31souttj.execute-api.eu-west-1.amazonaws.com/prod/graphql'
});

const retryLink = new RetryLink({
  delay: {
    initial: 400,
    max: 2500,
    jitter: true,
  },
  attempts: {
    max: 3,
    retryIf: (error) => !!error && !error.result,
  },
});

const authLink = setContext((_, { headers }) => {
  // Hent token fra localStorage
  const token = localStorage.getItem('token');
  
  // Return headers med token hvis den findes
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});

const client = new ApolloClient({
  link: authLink.concat(retryLink).concat(httpLink),
  // KnockoutMatch bruger samme id på tværs af runder (fx match-1 i Round of 16 og kvartfinaler).
  // Uden dette kolliderer cache-nøgler — sidste skrivning vinder og winner/home/away bliver forkerte.
  cache: new InMemoryCache({
    typePolicies: {
      KnockoutMatch: {
        keyFields: false,
      },
    },
  }),
  defaultOptions: {
    watchQuery: {
      // Vis cache med det samme, men hent altid frisk data ved mount (undgår tom cache-stall).
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'ignore',
    },
  },
});

export default client; 